import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  FiCopy,
  FiCheck,
  FiUpload,
  FiImage,
  FiLoader,
  FiAlertCircle,
  FiCheckCircle, FiHome, FiChevronRight,
} from "react-icons/fi";

import {
  getQr,
  getProfile,
  submitJoiningPayment,
} from "../../store/slices/profile";

import axiosInstance from "../../utils/authUtils";

import {
  API_PATHS,
} from "../../utils/constants/api.constants";

const JoiningPayment = () => {
  const dispatch = useDispatch();

  const fileInputRef = useRef(null);

  const {
    qrData = null,
    qrLoading = false,
    profilelist = {},
    loading = false,
  } = useSelector((state) => state.profile);


  const [trn, setTrn] = useState("");
  const [trnImage, setTrnImage] = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const [uploading, setUploading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [copied, setCopied] = useState(false);

  const [paymentSubmitted, setPaymentSubmitted] = useState(false);


  const amount = 32;

  useEffect(() => {
    dispatch(getQr());
    dispatch(getProfile());
  }, [dispatch]);


  const profileData =
    profilelist?.data ||
    profilelist ||
    {};


  const joiningStatus =
    profileData?.joiningStatus ||
    "";

  const normalizedStatus =
    String(joiningStatus).toUpperCase();

  const isPending =
    normalizedStatus === "PENDING";

  const isPaid =
    normalizedStatus === "PAID";

  const isSuccess =
    normalizedStatus === "SUCCESS";

  const isRejected =
    normalizedStatus === "REJECTED";


  const qr = qrData || {};

  const qrImage =
    qrData?.image ||
    qrData?.qrImage ||
    qrData?.url ||
    qrData?.location ||
    "";


  const walletAddress =
    qrData?.walletaddress
  "";



  const handleCopyAddress = async () => {
    if (!walletAddress) return;

    try {
      await navigator.clipboard.writeText(
        walletAddress
      );

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);

    } catch (err) {
      console.error(
        "COPY ADDRESS ERROR:",
        err
      );

      setError(
        "Failed to copy wallet address"
      );
    }
  };


  const handleUploadClick = () => {
    setError("");

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };


  const handleImageUpload = async (e) => {
    setError("");

    const file =
      e.target.files?.[0];

    if (!file) {
      return;
    }



    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
    ];

    if (
      !allowedTypes.includes(
        file.type.toLowerCase()
      )
    ) {
      setError(
        "Only JPG, JPEG, PNG and WEBP files are allowed"
      );

      return;
    }


    if (
      file.size >
      10 * 1024 * 1024
    ) {
      setError(
        "Image size must be less than 10 MB"
      );

      return;
    }



    const localPreview =
      URL.createObjectURL(file);

    setPreviewImage(localPreview);

    setUploading(true);

    try {
      const formData = new FormData();

      formData.append(
        "file",
        file
      );

      const response =
        await axiosInstance.post(
          API_PATHS.userFileUpload,
          formData
        );

      const data =
        response?.data;

      console.log(
        "IMAGE UPLOAD RESPONSE:",
        data
      );

      if (
        (
          data?.status === 1 ||
          data?.status === true
        ) &&
        data?.data?.location
      ) {
        const imageUrl =
          data.data.location;

        setTrnImage(imageUrl);

        setPreviewImage(imageUrl);

      } else {
        throw new Error(
          data?.message ||
          "Failed to upload transaction image"
        );
      }

    } catch (err) {
      console.error(
        "UPLOAD ERROR:",
        err
      );

      setError(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to upload transaction image"
      );

      setTrnImage("");
      setPreviewImage("");

    } finally {
      setUploading(false);
    }
  };

  /* =========================
     REMOVE / CHANGE IMAGE
  ========================= */

  const handleRemoveImage = () => {
    setTrnImage("");
    setPreviewImage("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  /* =========================
     SUBMIT PAYMENT
  ========================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");


    if (!trn.trim()) {
      setError(
        "Please enter Transaction Hash Number"
      );

      return;
    }

    if (!trnImage) {
      setError(
        "Please upload Transaction Image"
      );

      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        amount,
        trn: trn.trim(),
        trnImage,
      };

      console.log(
        "SUBMIT PAYMENT PAYLOAD:",
        payload
      );

      const response =
        await dispatch(
          submitJoiningPayment(payload)
        ).unwrap();

      console.log(
        "PAYMENT RESPONSE:",
        response
      );

      setSuccess(
        response?.message ||
        "Payment request submitted successfully"
      );

      setPaymentSubmitted(true);

      setTrn("");
      setTrnImage("");
      setPreviewImage("");

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      /* Refresh profile */

      dispatch(getProfile());

    } catch (err) {
      console.error(
        "PAYMENT ERROR:",
        err
      );

      setError(
        typeof err === "string"
          ? err
          : err?.message ||
          "Failed to submit payment request"
      );

    } finally {
      setSubmitting(false);
    }
  };

  if (loading && !profileData?._id) {
    return (
      <div className="gi-payment-page">

        <div className="gi-payment-loading">
          <FiLoader />

          <span>
            Loading payment details...
          </span>
        </div>

      </div>
    );
  }

  const renderStatusContent = () => {
    if (paymentSubmitted) {
      return (
        <div className="gi-payment-status-content">

          <FiCheckCircle />

          <h3>
            Payment Request Submitted
          </h3>

          <p>
            Your joining payment request has been
            submitted successfully and is waiting
            for admin approval.
          </p>

        </div>
      );
    }

    if (isPaid || isSuccess) {
      return (
        <div className="gi-payment-status-content success">

          <FiCheckCircle />

          <h3>
            Payment Successful
          </h3>

          <p>
            Your joining payment has been
            successfully approved.
          </p>

        </div>
      );
    }

    if (isRejected) {
      return (
        <div className="gi-payment-status-content rejected">

          <FiAlertCircle />

          <h3>
            Payment Rejected
          </h3>

          <p>
            Your payment request was rejected.
            Please submit your payment details again.
          </p>

        </div>
      );
    }

    return (
      <div className="gi-payment-status-content">

        <FiAlertCircle />

        <h3>
          Payment Status
        </h3>

        <p>
          Current status:
          {" "}

          <strong>
            {joiningStatus || "-"}
          </strong>
        </p>

      </div>
    );
  };


  return (
    <>
      <div className="gi-transfer-page">

        <div className="gi-breadcrumb">

          <Link to="/dashboard">
            <FiHome />
            Dashboard
          </Link>

          <FiChevronRight className="gi-breadcrumb-arrow" />

          <span>
            Package Request
          </span>

        </div>


        <div className="gi-payment-card">

          {success && (
            <div className="gi-payment-success">

              <FiCheck />

              <span>
                {success}
              </span>

            </div>
          )}


          {error && (
            <div className="gi-payment-error">

              <FiAlertCircle />

              <span>
                {error}
              </span>

            </div>
          )}



          {isPending && !paymentSubmitted ? (

            <form
              onSubmit={handleSubmit}
            >


              <div className="gi-payment-qr-section">

                {qrLoading ? (

                  <div className="gi-qr-loading">

                    <FiLoader />

                    <span>
                      Loading QR Code...
                    </span>

                  </div>

                ) : qrImage ? (

                  <img
                    src={qrImage}
                    alt="USDT Payment QR"
                    className="gi-payment-qr"
                  />

                ) : (

                  <div className="gi-payment-no-qr">

                    <FiImage />

                    <span>
                      QR Code not available
                    </span>

                  </div>

                )}


                <h4>
                  Scan the QR code to make payment
                </h4>



              </div>


              {/* ================= WALLET ADDRESS ================= */}

              {walletAddress && (

                <div className="gi-payment-address">

                  <div className="gi-payment-address-text">

                    {walletAddress}

                  </div>


                  <button
                    type="button"
                    onClick={handleCopyAddress}
                    className="gi-copy-btn"
                  >

                    {copied ? (
                      <>
                        <FiCheck />
                        Copied
                      </>
                    ) : (
                      <>
                        <FiCopy />
                        Copy Address
                      </>
                    )}

                  </button>

                </div>

              )}


              {/* ================= AMOUNT ================= */}

              <div className="gi-payment-form-group">

                <label>
                  Amount (USDT BEP20)
                </label>

                <input
                  type="text"
                  value={amount}
                  readOnly
                  className="gi-payment-input"
                />

              </div>


              {/* ================= TRN ================= */}

              <div className="gi-payment-form-group">

                <label>
                  Transaction Hash Number
                  <span>*</span>
                </label>

                <input
                  type="text"
                  value={trn}
                  onChange={(e) =>
                    setTrn(e.target.value)
                  }
                  placeholder="Enter Transaction Hash Number"
                  className="gi-payment-input"
                />

              </div>


              {/* ================= TRANSACTION IMAGE ================= */}

              <div className="gi-payment-form-group">

                <label>
                  Transaction Image
                  <span>*</span>
                </label>


                <div className="gi-payment-upload-box">

                  {previewImage ? (

                    <div className="gi-payment-preview">

                      <img
                        src={previewImage}
                        alt="Transaction Preview"
                      />


                      <div className="gi-payment-preview-actions">

                        <button
                          type="button"
                          className="gi-payment-change-image"
                          onClick={handleUploadClick}
                          disabled={uploading}
                        >

                          <FiUpload />

                          Change

                        </button>


                        <button
                          type="button"
                          className="gi-payment-remove-image"
                          onClick={handleRemoveImage}
                          disabled={uploading}
                        >
                          Remove
                        </button>

                      </div>

                    </div>

                  ) : (

                    <button
                      type="button"
                      className="gi-payment-upload-btn"
                      onClick={handleUploadClick}
                      disabled={uploading}
                    >

                      {uploading ? (
                        <>
                          <FiLoader />

                          Uploading...
                        </>
                      ) : (
                        <>
                          <FiUpload />

                          Upload Transaction Image
                        </>
                      )}

                    </button>

                  )}

                </div>

              </div>


              {/* ================= SUBMIT ================= */}

              <button
                type="submit"
                className="gi-payment-submit-btn"
                disabled={
                  uploading ||
                  submitting ||
                  !trnImage
                }
              >

                {submitting ? (
                  <>
                    <FiLoader />

                    Submitting...
                  </>
                ) : (
                  "Submit USDT Request"
                )}

              </button>

            </form>

          ) : (

            renderStatusContent()

          )}


          {/* ================= HIDDEN FILE INPUT ================= */}

          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/webp"
            onChange={handleImageUpload}
            style={{
              display: "none",
            }}
          />

        </div>

      </div>
    </>
  );
};

export default JoiningPayment;